import './StyleSheets/footer.css'

export default function MensahStudiosFooter(){
  return(
    <div className='company-footer-field'>
      <h1>A <a href='https://mensahstudios.com' target='_blank'>Mensah Stuidos</a> Product</h1>
    </div>
  )
}